<template>
  <section></section>
</template>
<script>
import { mapGetters } from 'vuex'
import { OS_INSTALLATION_REQ } from '@/store/modules/os_support/os-support.type'

export default {
  name: 'OsInstallInstructions',
  props: {
    environment: {
      default: '',
      type: [String]
    },
    customerName: {
      default: '',
      type: [String]
    },
    version: {
      default: '',
      type: [String]
    },
    os: {
      type: [Object, String],
      default: () => {
        return {
          os_name: 'Ubuntu',
          os_version: '16 | 18 | 20 | 22 LTS',
          file_name: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters(['osDownloadProgress'])
  },
  methods: {
    downloadPackage() {
      if (_.indexOf(['start', 'loading'], this.osDownloadProgress.status) < 0) {
        this.$store
          .dispatch(OS_INSTALLATION_REQ, {
            osName: this.os.os_name,
            osType: this.os.os_version,
            osFilename: this.os.file_name
          })
          .then(
            () => {
              this.$message({
                type: 'success',
                message: 'Installation package downloaded.'
              })
            },
            errMsg => {
              this.$message({
                type: 'error',
                message: 'Error retreiving installation package.'
              })
            }
          )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/os-template/OsInstallInstructions.vue